export default {
  submittedCedentInformation: false,
  cedentInformation: {
    cedentName: '',
    cedentEmail: '',
    cedentNumber: '',
    cedentAddress: '',
  }
}